import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, Mail, LayoutDashboard, Sparkles, History, CreditCard, UserCircle2 } from "lucide-react";

const nav = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/generate", label: "Generate", icon: Sparkles },
  { to: "/history", label: "History", icon: History },
  { to: "/billing", label: "Billing", icon: CreditCard },
  { to: "/profile", label: "Profile", icon: UserCircle2 },
];

export default function AppShell({ children }) {
  const { user, plan, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="app-logo">
            <img src="https://customer-assets.emergentagent.com/job_jd-mailer-pro/artifacts/25t7dqsa_Untitled%20design%20%2835%29.png" alt="Aplica" className="h-8 w-8 rounded-md" />
            <span className="font-display font-semibold text-lg tracking-tight text-slate-900">Aplica</span>
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm flex items-center gap-2 transition-colors ${
                    isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"
                  }`
                }
              >
                <n.icon className="h-4 w-4" /> {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            {plan && (
              <span className="hidden sm:inline-flex text-xs font-medium px-2.5 py-1 rounded-full border border-slate-200 bg-white text-slate-700" data-testid="plan-badge">
                {plan.name} · {plan.quota}/mo
              </span>
            )}
            <button
              onClick={() => { logout(); navigate("/"); }}
              className="text-slate-500 hover:text-slate-900 p-2 rounded-md hover:bg-slate-100 transition-colors"
              data-testid="logout-button"
              title={user?.email}
            >
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="max-w-7xl mx-auto px-4 py-2 flex gap-1 overflow-x-auto">
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to}
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-md text-xs flex items-center gap-1.5 whitespace-nowrap ${
                    isActive ? "bg-slate-900 text-white" : "text-slate-600"
                  }`
                }>
                <n.icon className="h-3.5 w-3.5" /> {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-10">{children}</main>
    </div>
  );
}
